import * as yup from "yup";
import { GetErrorObject } from "../Utils";

export const RegistrationSchema = yup.object().shape({
  Customer: yup
    .string()
    .transform((value) => value || "")
    .required("Customer Name is required."),
});

export function ValidateCustomer(input) {
  return new Promise(async function (resolve, reject) {
    try {
      RegistrationSchema.validate(input, { abortEarly: false })
        .then(function () {
          const { Customer } = input;
          const data = {
            Customer: {
              ...input,
            },
          };
          resolve({ data });
        })
        .catch(function (err) {
          const errors = GetErrorObject(err);
          resolve({ errors });
        });
    } catch (e) {
      reject(e);
    }
  });
}
